import { iWord, iWordHistory } from "@/lib/types";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "./ui/card";
import { Badge } from "@/components/ui/badge";

interface iQuiz {
  currentQuestion?: iWord;
  choices?: string[];
  onClick: (selectedAnswer: string) => void;
  choice?: string;
  onQuizEnd?: () => void;
  wordHistory: iWordHistory;
}

export const Quiz = ({
  currentQuestion,
  choice,
  choices,
  onClick,
  onQuizEnd,
  wordHistory,
}: iQuiz) => {
  const currentWordHistory = wordHistory[currentQuestion?.id as string];
  const currentCategory = currentWordHistory?.category;
  return (
    <div className="mt-12">
      <div className="mb-10 flex justify-center gap-5">
        {currentQuestion && <Badge>{currentQuestion?.type}</Badge>}

        {currentCategory && (
          <Badge
            className={`uppercase ${currentCategory === "weak" ? "bg-red-800" : currentCategory === "medium" ? "bg-amber-600" : "bg-green-800"}`}
          >
            {currentCategory}
          </Badge>
        )}
      </div>
      <div className="text-center font-arabic text-5xl font-semibold">
        {currentQuestion?.arabic}
      </div>

      {!currentQuestion && (
        <div className="text-xl">
          <Card className="bg-card-adaptive mt-10">
            <CardHeader>
              <CardTitle className="text-title-adaptive">
                No more questions
              </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-2">
              <p className="text-body-adaptive text-lg">
                No more questions left with the current settings. End quiz and
                choose another set of filters.
              </p>
            </CardContent>
          </Card>
        </div>
      )}
      {currentQuestion && (
        <div className="mt-10 text-center">
          Appears {currentQuestion?.occurrence} times in the Quran
        </div>
      )}

      <div className="mt-10 flex flex-col justify-center gap-2">
        {choices?.map((row) => (
          <Button
            key={row}
            onClick={() => onClick(row)}
            className={`py-10 capitalize transition-all ${choice ? `${currentQuestion?.english === row ? "bg-green-600 hover:bg-green-600 active:bg-green-600" : "bg-red-600 hover:bg-red-600 active:bg-red-600"}` : ""}`}
          >
            {choice === row
              ? currentQuestion?.english === row
                ? "✔️"
                : "❌"
              : ""}
            {row}
          </Button>
        ))}
      </div>

      <div className="mt-10 flex justify-end">
        <Button className="p-5" onClick={onQuizEnd}>
          End quiz
        </Button>
      </div>
    </div>
  );
};
